module.exports = __webpack_public_path__ + "static/media/13.afce226f.gif";